<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
        <a class="navbar-brand" href="/">MESADE</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" href="/">Inicio</a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        Proyectos
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li><a class="dropdown-item" href="/pillar_1">Mujer, Cuerpo y Salud</a></li>
                        <li><a class="dropdown-item" href="/pillar_2">ARISE</a></li>
                        <li><a class="dropdown-item" href="/pillar_3/felpudo">FELPUDO</a></li>
                        <li><a class="dropdown-item" href="/pillar_3/fona">FONA</a></li>
                    </ul>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" href="#">Acerca de</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Contacto</a>
                </li> -->
            </ul>
        </div>
    </div>
</nav>

<router-outlet></router-outlet>

<footer class="bg-dark text-light">
    <!-- Contact Information -->
    <div class="contact-information"></div>

    <!-- Main Footer Content -->
    <div class="container">
        <div class="row g-4">
            <!-- About Section -->
            <div class="col-md-4">
                <h4>Acerca MES</h4>
                <p class="mb-3">Descripción sobre MESADE puede ir aquí...</p>
                <div class="social-icons">
                    <a href="#" class="text-decoration-none me-2"><i class="bi bi-twitter"></i></a>
                    <a href="#" class="text-decoration-none me-2"><i class="bi bi-facebook"></i></a>
                    <a href="#" class="text-decoration-none me-2"><i class="bi bi-linkedin"></i></a>
                    <a href="#" class="text-decoration-none"><i class="bi bi-dribbble"></i></a>
                </div>
            </div>

            <!-- Site Map -->
            <div class="col-md-4">
                <h4>Mapa del sitio</h4>
                <ul class="list-unstyled">
                    <li class="mb-2"><a href="#motivacion" class="text-decoration-none"><i
                                class="bi bi-check-circle me-2"></i>Motivación</a></li>
                    <li class="mb-2"><a href="#problematica" class="text-decoration-none"><i
                                class="bi bi-check-circle me-2"></i>Problematica</a></li>
                    <li class="mb-2"><a href="#propuesta" class="text-decoration-none"><i
                                class="bi bi-check-circle me-2"></i>Propuesta</a></li>
                    <li class="mb-2"><a href="#resultados" class="text-decoration-none"><i
                                class="bi bi-check-circle me-2"></i>Resultados</a></li>
                    <li class="mb-2"><a href="#recursosdescargables" class="text-decoration-none"><i
                                class="bi bi-check-circle me-2"></i>Recursos descargables</a></li>
                    <li class="mb-2"><a href="#equipo" class="text-decoration-none"><i
                                class="bi bi-check-circle me-2"></i>Equipo</a></li>
                    <li><a href="#contacto" class="text-decoration-none"><i
                                class="bi bi-check-circle me-2"></i>Contacto</a></li>
                </ul>
            </div>

            <!-- Contact Information -->
            <div class="col-md-4 ">
                <h4>Información de <br>Contacto</h4>
                <ul class="list-unstyled">
                    <li class="mb-2">Cuenca - Ecuador <br> Calle Vieja 12-30 y Elia Liut <br> Edificio Cornelio Merchán,
                        planta baja.</li>
                    <li class="mb-2"><a href="tel:+59374135250" class="text-decoration-none"><i
                                class="bi bi-telephone me-2"></i>(+593) 74135250 ext 1278</a></li>
                    <li class="mb-2"><a href="mailto:catedraunescoinclusion@ups.edu.ec" class="text-decoration-none"><i
                                class="bi bi-envelope me-2"></i>catedraunescoinclusion</a></li>
                    <li><a href="http://catedraunescoinclusion.org/" class="text-decoration-none"><i
                                class="bi bi-globe me-2"></i>catedraunescoinclusion.org</a></li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Copyright -->
    <div class=" bg-warning mt-4">
        <div class="row">
            <div class="col-12 text-center ">
                <p class="mb-0">
                    <small class="text-dark">
                        Copyright ©
                        <script>document.write(new Date().getFullYear());</script>
                        All rights reserved by <a href="https://ups.edu.ec/" target="_blank"
                            class="text-decoration-none">UPS</a>
                    </small>
                </p>
            </div>
        </div>
    </div>
</footer>